import styled from 'styled-components'

import { Pill } from '@sketch/components'

export const StyledPill = styled(Pill)`
  margin-left: 4px;
`
